import { inject, Injectable } from '@angular/core';
import { ApiCallingV2Service, API_CONFIG } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import { CreateDepositSchedulePayload } from '@zayan-erp/sales';

@Injectable({
  providedIn: 'root'
})
export class ProjectDepositScheduleService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getDepositsByProject(projectId: string): Observable<any> {
    return this.#http.getData(`${this.baseUrl}/deposit-schedules/project/${projectId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  getDepositRowsById(id: string): Observable<any> {
    return this.#http.getData(`${this.baseUrl}/deposit-schedules/${id}/rows`, { showLoader: true, showMessage: false });
  }

  createDepositSchedule(projectId: string, depositSchedule: CreateDepositSchedulePayload[]): Observable<any> {
    return this.#http.postData(
      `${this.baseUrl}/deposit-schedules/project/${projectId}/rows`,
      { showLoader: true, showMessage: true },
      depositSchedule
    );
  }

  updateDepositSchedule(id: string, depositSchedule: any): Observable<any> {
    return this.#http.putData(`${this.baseUrl}/deposit-schedules/rows/${id}`, depositSchedule, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteDepositSchedule(id: string): Observable<any> {
    return this.#http.deleteData(`${this.baseUrl}/deposit-schedules/rows/${id}`, {
      showLoader: true,
      showMessage: true
    });
  }
}
